import { apiGetCart } from '@/api/API';

const cachedCount = () => {
    try {
        return Number(localStorage.getItem('courseCartCachedCount')) || 0;
    } catch {
        return 0;
    }
};

export default {
    namespaced: true,
    state: {
        count: cachedCount(),
        loading: false,
        loaded: false,
    },
    mutations: {
        setCount(state, count) {
            state.count = count;
            try {
                localStorage.setItem('courseCartCachedCount', String(count));
            } catch {
                // ignore storage errors
            }
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setLoaded(state, val) {
            state.loaded = val;
        },
    },
    actions: {
        async fetchCount({ commit }) {
            commit('setLoading', true);
            try {
                const res = await apiGetCart();
                const groups = Array.isArray(res.data) ? res.data : [];
                const items = (groups[0] && Array.isArray(groups[0].CartDto)) ? groups[0].CartDto : [];
                commit('setCount', items.length);
                commit('setLoaded', true);
            } catch {
                // 讀取失敗時保留目前的購物車快取數量，避免暫時性錯誤把角標數字閃成 0
            } finally {
                commit('setLoading', false);
            }
        },
    },
};
